module.exports = __webpack_public_path__ + "img/home.83d17db2.png";